import { useTranslation } from "react-i18next";

export default function DetailsSection() {
  const { t } = useTranslation();

  return (
    <section id="details" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("details_title")}
        </h2>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
              {t("details_location")}
            </h3>
            <p className="text-gray-700 text-center leading-relaxed">
              {t("details_location_value")}
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-gift-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
              {t("details_trial")}
            </h3>
            <p className="text-gray-700 text-center leading-relaxed">
              {t("details_trial_value")}
            </p>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-calendar-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
              {t("details_start")}
            </h3>
            <p className="text-gray-700 text-center leading-relaxed">
              {t("details_start_value")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
